// extracted by mini-css-extract-plugin
export default {"languageFieldset":"user-email-language-preferences_languageFieldset__v78WL","radio":"user-email-language-preferences_radio__thY6h"};